import { useMemo } from 'react';
import { css } from '@emotion/css';

const getHeight = () => css`
  height: calc(100vh - var(--ly-header-height, 0px));
`;

const getMaxHeight = () => css`
  max-height: calc(100vh - var(--ly-header-height, 0px));
`;

const getTopStickyPosition = () => css`
  top: var(--ly-header-height, 0px);
`;

export default function useBodyHeightStyles() {
  const bodyHeightStyles = useMemo(() => getHeight(), []);
  const bodyMaxHeightStyles = useMemo(() => getMaxHeight(), []);
  const topStickyPositionStyles = useMemo(() => getTopStickyPosition(), []);

  return {
    bodyHeightStyles,
    bodyMaxHeightStyles,
    topStickyPositionStyles,
  };
}
